import { api } from "@/lib/api";
import { visitTrackingAllowed } from "@/lib/consent";

// Fire-and-forget page-view tracking. De-dupes per path within a browser session.
// Respects cookie consent — skips when the visitor has declined.
export function trackVisit(path, storeHandle = "") {
  if (!visitTrackingAllowed()) return;
  try {
    const key = `sv:${path}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    api.post("/public/track/visit", {
      path,
      store_handle: storeHandle,
      referrer: document.referrer || "",
    }).catch((e) => { console.debug("track: visit post failed", e); });
  } catch (e) { console.debug("track: visit failed", e); }
}
